import React from "react";
import ReactHtmlParser from "react-html-parser";
import "./index.css";

/**
 * Closing "last updated" stamp and legal disclaimer.
 *
 * The ACF field holds only the date ("August 2026"); "Last updated" is a fixed
 * UI label, matching the design.
 */
const HempBanDisclaimer = ({ footerSection }) => {
  if (!footerSection) {
    return null;
  }

  const { lastUpdated, disclaimer } = footerSection;

  if (!lastUpdated && !disclaimer) {
    return null;
  }

  return (
    <section className="hb-disclaimer">
      <div className="hb-disclaimer-wrap">
        {lastUpdated ? (
          <p className="hb-disclaimer-updated">Last updated {lastUpdated}</p>
        ) : null}
        {disclaimer ? (
          <div className="hb-disclaimer-text hb-rich">
            {ReactHtmlParser(disclaimer)}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default HempBanDisclaimer;
